import api from './api';

export const requestWhatsappActivation = async (workspaceId, botId, phoneNumber) => {
  const { data } = await api.post(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/request`, { phoneNumber });
  return data;
};

export const getWhatsappActivationStatus = async (workspaceId, botId) => {
  const { data } = await api.get(`/workspaces/${workspaceId}/bots/${botId}/whatsapp`);
  return data;
};

export const getWhatsappPricing = async (workspaceId, botId) => {
  const { data } = await api.get(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/pricing`);
  return data;
};

export const listWhatsappTemplates = async (workspaceId, botId) => {
  const { data } = await api.get(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/templates`);
  return data;
};

export const createWhatsappTemplate = async (workspaceId, botId, payload) => {
  const { data } = await api.post(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/templates`, payload);
  return data;
};

export const submitWhatsappTemplate = async (workspaceId, botId, id) => {
  const { data } = await api.post(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/templates/${id}/submit`);
  return data;
};

export const syncWhatsappTemplates = async (workspaceId, botId) => {
  const { data } = await api.post(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/templates/sync`);
  return data;
};

export const deleteWhatsappTemplate = async (workspaceId, botId, id) => {
  const { data } = await api.delete(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/templates/${id}`);
  return data;
};

export const getWhatsappDeliveryWebhook = async (workspaceId, botId) => {
  const { data } = await api.get(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/delivery-webhook`);
  return data;
};

export const saveWhatsappDeliveryWebhook = async (workspaceId, botId, payload) => {
  const { data } = await api.patch(`/workspaces/${workspaceId}/bots/${botId}/whatsapp/delivery-webhook`, payload);
  return data;
};
